import { client } from "./index";
import { vendor } from "../Constant/index";

export const login = (payload) => client.post(`customer/login`, payload);
export const signUp = (payload) => client.post(`customer/register`, payload);

